import styles from "./perfil-karlyse.module.css";
import PerfilCover from "../../../components/EquipeComponents/PerfilCover/perfil-cover";
import karlysePerfil from "../../../images/_finais/Foto-Karlyse_compress.webp";

const PerfilKarlyse = () => {
  const onClickLink = (link: string) => {
    return window.open(link, "_blank");
  };

  return (
    <main className={styles.perfil_main}>
      <PerfilCover
        title="Karlyse Claudino Belli"
        text="Possui experiência de mais de 15 anos em estudos de mundo real 
        (Real World Evidence e Real World Data, RWE/RWD). Com sólida formação 
        na área, incluindo mestrado e doutorado na área da Saúde, e experiências 
        ligadas ao Ministério da Saúde, ANS e diferentes Sociedades Médicas 
        Brasileiras. Atuou como diretora de área em consultoria multinacional, 
        atendendo diversos clientes da Indústria Farmacêutica em projetos de 
        RWE/RWD executados no Brasil, na América Latina e Globais."
        image={karlysePerfil}
        lattes={"http://lattes.cnpq.br/5648099121383504"}
        linkedin={"https://www.linkedin.com/in/karlyse/"}
      />
      <p className={styles.descriptionMobile}>
        Possui experiência de mais de 15 anos em estudos de mundo real (Real
        World Evidence e Real World Data, RWE/RWD). Com sólida formação na área,
        incluindo mestrado e doutorado na área da Saúde, e experiências ligadas
        ao Ministério da Saúde, ANS e diferentes Sociedades Médicas Brasileiras.
        Atuou como diretora de área em consultoria multinacional, atendendo
        diversos clientes da Indústria Farmacêutica em projetos de RWE/RWD
        executados no Brasil, na América Latina e Globais.
      </p>
      <section className={styles.publicacoes}>
        <h3 className={styles.publicacoesTitle}>
          Publicações em Real World Evidence nos últimos anos:
        </h3>
        <ul className={styles.publicacoesList}>
          <li className={styles.publicacoesItem}>
            • Validation of the OPEN-CLEAN Chronic Total Occlusion Percutaneous
            Coronary Intervention Perforation Score in a Multicenter Registry.
            American Journal Of Cardiology, v. 188, p. 30-35, 2023.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.ajconline.org/article/S0002-9149(22)01220-6/abstract"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Risk Burden of Coronary Perforation in Chronic Total Occlusion
            Recanalization: Latin American CTO Registry Analysis. Journal of the
            American Heart Association, v. 11, p. e024815, 2022.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.ahajournals.org/doi/full/10.1161/JAHA.121.024815?rfr_dat=cr_pub++0pubmed&url_ver=Z39.88-2003&rfr_id=ori%3Arid%3Acrossref.org"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • In-stent chronic total occlusion angioplasty in the registry.
            Catheterization And Cardiovascular Interventions, v. 97, p. E34-E39,
            2021.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.jacc.org/doi/10.1016/j.jcin.2021.04.003"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • In-Stent CTO Percutaneous Coronary Intervention.
            JACC-Cardiovascular Interventions, v. 14, p. 1308-1319, 2021.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.jacc.org/doi/10.1016/j.jcin.2021.04.003"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Risk Stratification in Chest Pain: Impact on the Diagnosis of
            Acute Coronary Syndrome. International Journal Of Cardiovascular
            Sciences (ONLINE), v. 34, p. 67-73, 2020.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.scielo.br/j/ijcs/a/6zBH5RfFFGbXx6557rqzzhz/"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Chronic total occlusion percutaneous coronary intervention in
            Latin America. Catheterization And Cardiovascular Interventions, v.
            96, p. 1046-1055, 2020.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://onlinelibrary.wiley.com/doi/10.1002/ccd.28744"
                )
              }
            >
              Ver
            </button>
          </li>
          <li className={styles.publicacoesItem}>
            • Classification System for Cardiorespiratory Fitness Based on a
            Sample of the Brazilian Population. International Journal of
            Cardiovascular Sciences, v. 34, p. 343-354, 2019.
            <button
              className={styles.btnVer}
              onClick={() =>
                onClickLink(
                  "https://www.scielo.br/j/ijcs/a/x8bB3qQHQKCXHRbZRbpXMrm/?lang=en"
                )
              }
            >
              Ver
            </button>
          </li>
        </ul>
      </section>
    </main>
  );
};

export default PerfilKarlyse;
